export function TheGrandTourIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="20" r="12" />
      <path d="M16 20c0-5 4-8 8-8" />
      <circle cx="24" cy="20" r="3" />
      <path d="M24 32v6" />
      <path d="M18 40h12" />
      <line x1="24" y1="38" x2="18" y2="42" />
      <line x1="24" y1="38" x2="30" y2="42" />
    </svg>
  );
}
